import { createContext } from 'react'
import type { UseEntitlementsReturn } from '@hapana/shared/web/hooks/entitlements.hooks'

export const EntitlementsContext = createContext<UseEntitlementsReturn | null>(null)
